module.exports = __webpack_public_path__ + "img/kankou_21.722c6b65.jpg";